<template>
	<v-container v-if="show" grid-list-xl>
		<v-layout
			row
			wrap
			align-center
			justify-center
		>
			<v-flex
				xs12
				md8
				pa-0
			>
				<slot name="alert" />
			</v-flex>
		</v-layout>
		<v-layout row justify-center>
			<v-flex pa-0 xs12 lg9>
				<EditProject
					:edit-project="project"
					:existing-projects="projectNames"
					:closable="false"
				/>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import EditProject from '@/components/Project/EditProject';

export default {
	components: {
		EditProject,
	},
	data() {
		return {
			show: false,
		};
	},
	created() {
		// Redirect to not found if user doesn't have permission to settings
		/** @todo Improve on global level, good for now */
		this.show = this.project.userCan('manage_projects');
		if (!this.show) {
			this.$router.replace({ name: 'NotFound' });
		}
	},
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
		projects() {
			return this.$store.get('projects/all');
		},
		projectNames() {
			return this.projects.getNames().filter(name => name !== this.project.name);
		},
	},
};
</script>
